module.exports = __webpack_public_path__ + "img/2025-0327-02-01.09957ea3.png";